var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraph01({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "icon-001",
    id: "Shape_Copy_4",
    "data-name": "Shape Copy 4",
    d: "M6,10H4V0H6V10ZM2,10H0V3H2v7Zm8,0H8V6h2v4Z",
    transform: "translate(10) rotate(90)",
    fill: "#b5c5d2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraph01);
export default __webpack_public_path__ + "static/media/graph-01.51af2ce74ebe62a19f4bde658b008d0e.svg";
export { ForwardRef as ReactComponent };